import styled from 'styled-components';
import Screen from '../../../../shared/utils/screen';

const LanguageListArrowContainer = styled.div<React.CSSProperties>`
  top: ${-4 * Screen.widthRatio}px;
  left: ${-45 * Screen.widthRatio}px;
  position: absolute;
`;

export default LanguageListArrowContainer;
